import { strollers_api_get_brands_url } from 'mk/urls/functions';
import { ArticleSchema } from 'mk2/apps/blogs/schemas';
import { CounsellingSchema } from 'mk2/apps/forum/schemas';
import {
    brandsFetchApi,
    BrandsFetchNormalizedResponse,
    BrandsFetchTriggerAction,
    STROLLERS_BRANDS_LIST_FETCH_TRIGGER,
} from 'mk2/apps/strollers/containers/BrandsList/BrandsList.actions';
import { StrollerBrandSchema } from 'mk2/apps/strollers/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/fetchBrands.sagas');

function* fetchBrands({ after, xhr }: BrandsFetchTriggerAction & XHRAction) {
    yield put(brandsFetchApi.request(after));

    try {
        const response = yield call(
            () => xhr.get(strollers_api_get_brands_url({after})),
        );
        const normalizedResponse: BrandsFetchNormalizedResponse = normalize(response.body, {
            brands: [StrollerBrandSchema],
            guideArticles: [ArticleSchema],
            strollersCounselling: CounsellingSchema,
        });

        yield put(brandsFetchApi.success(after, response.body.hasMore, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(brandsFetchApi.failure(after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(STROLLERS_BRANDS_LIST_FETCH_TRIGGER, fetchBrands),
    ]);
}
